import styled from 'styled-components';

export const DateCellWrapper = styled.div`
`;
